export default [
  {
    path: '/404',
    component: () => import('@/views/system/exception/404/index.vue'),
  },
];
